



































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import windElement from '@/utils/windElement'
import CimissDataService from '@/service/CimissDataService'
// @ts-ignore
import skyconText from '@/utils/skyconText.js'
export default Vue.extend({
  props: ['address', 'longitude', 'latitude'],
  computed: {
    lngLat(): any {
      const { longitude, latitude } = this
      return { longitude, latitude }
    },
  },
  watch: {
    lngLat() {
      this.getData()
    },
  },
  data() {
    return {
      data: {},
      hywxData: '',
    }
  },
  created() {
    this.getData()
    this.getHywxData()
  },
  methods: {

    getData() {
      // console.log(JSON.parse(JSON.stringify(stationInfo)))
      // console.log(JSON.parse(JSON.stringify(countryStationInfo)))

      //获取最近站点
      // CimissDataService.nearestStation(config.defaultStationObj.areaCode, this.lngLat.longitude, this.lngLat.latitude).then((stationInfo: any) => {
        let staId = config.defaultStationObj.station_id_c
        let stationName =config.defaultStationObj.stationName
        // if (JSON.stringify(stationInfo) !== '{}') {
        //   staId = stationInfo.station_id_c
        //   stationName = stationInfo.station_name
        // }

        //国家站
        const countryStaId = config.defaultStationObj.station_id_c
        let staIds: string[] = [countryStaId]
        if (staId != '') {
          staIds.push(staId)
        }
        CimissDataService.hourHisData('staIds', staIds.join(','), '').then(res => {
          if (res && res.length > 0) {

            let nearestStationData = res.filter((e: any) => { return e.station_id_c === staId })
            let countryStationData = res.filter((e: any) => { return e.station_id_c === countryStaId })
            if (nearestStationData.length > 0) {
              nearestStationData = nearestStationData[0]
            }
            if (countryStationData.length > 0) {
              countryStationData = countryStationData[0]
            }
            const data = nearestStationData

            for (const key in data) {

              if (Object.prototype.hasOwnProperty.call(data, key)) {
                if (key === 'vis') {
                  data.vis = (data[key] / 1000).toFixed(1)
                }
               
                if (key === 'win_s_avg_2mi') {
                  data.windlevel = windElement.windLevel(data.win_s_avg_2mi)
                  data.winddirection = windElement.windDirection(data.win_d_avg_2mi)
                }
                if (key === 'datetime') {
                  data.liveTime = moment(data.datetime, 'YYYYMMDDHH').add(8, 'hours').format('HH:00')
                }
              }

            }

            if (data.rhu === '' || data.rhu === undefined || data.vis === '' || data.vis === undefined) {

              if (countryStationData) {
                if (data.rhu === '' || data.rhu === undefined) {
                  data.rhu = countryStationData.rhu
                }
                if (data.vis === '' || data.vis === undefined) {
                  data.vis = (countryStationData.vis / 1000).toFixed(1)
                }
              }
            }
            



            this.data = data
          }
        })

      // })








      // if (JSON.stringify(stationInfo) !== '{}') {
      //     staIds = stationInfo.station_id_c
      // }
      // WeatherData.hourHisData('staIds', staIds, '').then((res) => {
      //     if (res && res.length > 0) {
      //         const data = res[0]
      //         for (const key in data) {
      //             // data.windlevel = '--'
      //             // data.winddirection = '--'
      //             if (Object.prototype.hasOwnProperty.call(data, key)) {
      //                 if (key === 'vis' ) {
      //                     data.vis = (data[key] / 1000).toFixed(1)
      //                 }
      //                 if (key === 'win_s_avg_2mi') {
      //                     data.windlevel = windElement.windLevel(data.win_s_avg_2mi)
      //                     data.winddirection = windElement.windDirection(data.win_d_avg_2mi)
      //                 }
      //                 if (key === 'datetime') {
      //                     data.liveTime = moment(data.datetime, 'YYYYMMDDHH').add(8, 'hours').format('HH:00')
      //                 }
      //             }
      //         }
      //         this.$store.commit('setLiveData', data)
      //         // console.log(JSON.parse(JSON.stringify(data)))
      //         if (data.rhu === '' || data.rhu === undefined || data.vis === '' || data.vis === undefined) {
      //             this.$store.commit('setLiveData', {})
      //             // V8870就是国家站原57036，目前无数据，选一个其他近点国家站：57131
      //             // const countryStationId = countryStationInfo.station_id_c === 'V8870' ? '57131' : countryStationInfo.station_id_c
      //             const countryStationId = countryStationInfo.station_id_c
      //             WeatherData.hourHisData('staIds', countryStationId, '').then((resCountry) => {
      //                 // console.log(JSON.parse(JSON.stringify(resCountry[0])))
      //                 if (resCountry && resCountry.length > 0) {
      //                     const dataCountry = resCountry[0]
      //                     if (data.rhu === '' || data.rhu === undefined) {
      //                         // this.$set(data, 'rhu', dataCountry.rhu)
      //                         data.rhu = dataCountry.rhu
      //                     }
      //                     if (data.vis === '' || data.vis === undefined) {
      //                         // this.$set(data, 'vis', (dataCountry.vis / 1000).toFixed(1))
      //                         data.vis = (dataCountry.vis / 1000).toFixed(1)
      //                     }
      //                     this.$store.commit('setLiveData', data)
      //                 }
      //             })
      //         }
      //     }
      // })
    },


    // getData() {
    //     const url = `/v2.5/0woAfhHWQi4n5X9N/${this.lngLat.longitude},${this.lngLat.latitude}/realtime`
    //     request.get(url).then((result) => {
    //         // console.log(result.result.realtime)
    //         const realtime = result.result.realtime
    //         const data = {
    //             tem: (realtime.temperature).toFixed(1),
    //             wind: (realtime.wind.speed / 3.6).toFixed(1),
    //             pre: realtime.precipitation.local.intensity.toFixed(1),
    //             vis: (realtime.visibility).toFixed(1),
    //             prs: (realtime.pressure / 100).toFixed(1),
    //             // rhu: (realtime.humidity * 100).toFixed(0),
    //             skyconText: skyconText.skyconText(realtime.skycon),
    //             imgUrl: `/static/weatherIcon/${realtime.skycon}.png`,
    //             updateTime: moment(result.server_time * 1000).format('YYYY/MM/DD HH时mm分更新'),
    //         }
    //         this.data = data
    //     }).catch((err) => {
    //         console.log(err)
    //         this.$Message.warning(err)
    //     })
    // },
    getHywxData() {
      const url = `/wechatServ/hywx/msg`
      request.get(url).then((result) => {
        // console.log(result)
        this.hywxData = result
      }).catch((err) => {
        console.log(err)
        this.$Message.warning(err)
      })
    },
  },
})
